import cn from "classnames";
import BookShow from "components/shared/book/show";
import Loader from "components/shared/loader";
import { viewContainer } from "helpers/redux";
import policy from "policies";
import React from "react";
import { apply, getList } from "sources/organizationFeatureModules";
import FeatureModuleForm from "./form";

class ShowAdminOrganizationModules extends BookShow {
    get dropdActions() {
        return [];
    }

    getItem = (props) => {
        const { source, match } = props || this.props;
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        Promise.all([source.getItem(match.params), getList(match.params.id)]).then(([data, featureModules]) =>
            this.setState({ data, initial: data, featureModules, ...defParams }),
        );
    };

    renderModules = () => {
        const { roles, enums } = this.props;
        return (
            <>
                {this.state.featuresLoading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                {this.state.featureModules.map((module) => {
                    const toggleFeature = () => {
                        this.setState({ featuresLoading: true });
                        apply({
                            ...module,
                            organizationId: this.props.match.params.id,
                            isActive: !module.isActive,
                        }).then(() => {
                            getList(this.props.match.params.id).then((featureModules) =>
                                this.setState({ featureModules, featuresLoading: false }),
                            );
                        });
                    };
                    return (
                        <div className="card mb-3" key={module.featureModuleId}>
                            <div className="card-header d-flex justify-content-between">
                                <span>{module.featureModuleName ?? module.featureModuleType}</span>
                                {policy("user", { user: { roles } }).isAdminWithWriteAccess() && (
                                    <div
                                        className={cn("inline-btn", {
                                            "inline-btn--delete": module.isActive,
                                            "inline-btn--checkmark": !module.isActive,
                                        })}
                                        onClick={toggleFeature}
                                    >
                                        {module.isActive ? "Выключить" : "Включить"}
                                    </div>
                                )}
                            </div>
                            {module.isActive && (
                                <FeatureModuleForm
                                    {...module}
                                    organizationId={this.props.match.params.id}
                                    roles={roles}
                                    enums={enums}
                                />
                            )}
                        </div>
                    );
                })}
            </>
        );
    };

    renderBody = () => {
        return (
            <div className="pb-4">
                <h4 className="pb-3">{this.state.data.organization.name}</h4>
                {this.renderModules()}
            </div>
        );
    };
}

export default viewContainer(ShowAdminOrganizationModules, "adminorganizations");
